module.exports = __webpack_public_path__ + "media/tts_g1_g.8b69d672.mp3";